import { deleteFoldersFromFolderTable, getAllSubFolderIds, moveFolderToParentFolder, removeFolderFromParentFolder, } from 'owa-folders';
import { actionNames } from 'owa-mail-store-actions';
import deleteFolderService from 'owa-mail-store/lib/services/deleteFolderService';
import * as undoActions from 'owa-mail-undo';
import { handleServiceError } from 'owa-service-error';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
export default action('deleteFolder')(function deleteFolder(folders, folderId, softDelete, deletedItemsFolderId) {
    // Only need to worry about removing the top-most folder from its parent's
    // list of children
    var folderToDelete = folders.folderTable.get(folderId);
    undoActions.clearLastUndoableAction();
    removeFolderFromParentFolder(folders, folderToDelete);
    var folderIdsToDelete = getAllSubFolderIds(folderToDelete.FolderId.Id);
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = handleServiceError('deleteFolderWithoutConfirmation', format(strings.errorDeletingFolder, folderToDelete.DisplayName), function () {
        return deleteFolderService(folderId, softDelete);
    });
    // raise the stitch to notify list view component to update the list view store
    raiseAction(actionNames.DeleteFolderAction)(folderIdsToDelete);
    // In case of soft delete, remove the folder from the foldertable otherwise we move the fodler to the deleted items folder of corresponding mailbox
    if (softDelete) {
        deleteFoldersFromFolderTable(folders, folderIdsToDelete);
    }
    else {
        moveFolderToParentFolder(folders, folderToDelete, deletedItemsFolderId);
    }
    return actionResponse;
});
//# sourceMappingURL=deleteFolder.js.map